import React from 'react';
import {
  BrowserRouter,
  BrowserRouterProps,
  Redirect,
  Switch,
} from 'react-router-dom';
import { AdminPage, HomePage } from 'pages';
import { AdminRoute, MainRoute } from './routes';

const Router: React.FC<BrowserRouterProps> = () => {
  return (
    <BrowserRouter>
      <Switch>
        <MainRoute path="/" exact>
          <HomePage/>
        </MainRoute>
        <AdminRoute path="/fraegeglkJZAXNJDEZFILEJerzggfezqrvgeaAIMTONIYHJOjiohmjjkerdgniek" exact>
          <AdminPage/>
        </AdminRoute>
        <Redirect to="/"/>
      </Switch>
    </BrowserRouter>
  );
};

export default Router;